// extracted by mini-css-extract-plugin
module.exports = {"elementDecorate":"decorate_elementDecorate__e8cGv","placeholder":"decorate_placeholder__5yGIz"};